import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {TotalStorageUsageResponse} from './entities/total-storage-usage-response';
import {VerifyStorageAvailableResponse} from './entities/verify-storage-available-response';
import {ItemDeletedResponse} from '../../entities/base/item-deleted-response';
import {UpdateUpload} from './entities/upload';
import {ApiService} from '../base/api.service';
import {S3Service} from '../base/s3.service';
import {SignedUrlResponse} from '../../entities/base/signed-url-response';
import {VerifyStorageAvailableItemResponse} from './entities/verify-storage-available-item-response';
import {TotalStorageUsageItemResponse} from './entities/total-storage-usage-item-response';
import {HttpMethod} from '../../types/http-method.type';
import {ItemUpdatedResponse} from '../../entities';

@Injectable({
  providedIn: 'root'
})
export class UploadRepositoryService {


  constructor(
    private api: ApiService,
    private s3: S3Service
  ) {
  }

  getSignedUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.api.get<SignedUrlResponse>('uploads/generate-signed-url', {fileName: file, action: method, expires: expires})
      .pipe(map(response => response.value));
  }

  getSignedReportsUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.api.get<SignedUrlResponse>('uploads/practice-history-reports/generate-signed-url', {fileName: file, action: method, expires: expires})
      .pipe(map(response => response.value));
  }

  getSignedUploadsUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.api.get<SignedUrlResponse>('uploads/practice-uploads/generate-signed-url', {fileName: file, action: method, expires: expires})
      .pipe(map(response => response.value));
  }

  getSignedAssetsUrl(file: string, method: HttpMethod, expires: number): Observable<string> {
    return this.api.get<SignedUrlResponse>('uploads/practice-assets/generate-signed-url', {fileName: file, action: method, expires: expires})
      .pipe(map(response => response.value));
  }

  uploadFile(file: File, url: string): Observable<any> {
    return this.s3.uploadFile(url, file);
  }

  getTotalStorageUsage(): Observable<TotalStorageUsageResponse> {
    return this.api.get<TotalStorageUsageItemResponse>('uploads/storage/usage')
      .pipe(map(response => response.value));

  }

  verifyStorageAvailable(uploadSize: number): Observable<VerifyStorageAvailableResponse> {
    return this.api.get<VerifyStorageAvailableItemResponse>('uploads/storage/available', {uploadSize: uploadSize})
      .pipe(map(response => response.value));

  }

  updateFile(id: number, upload: UpdateUpload): Observable<boolean> {
    return this.api.put<ItemDeletedResponse>('uploads/' + id, upload)
      .pipe(map(response => response.status.toLocaleUpperCase() === 'OK'));
  }

  deleteFile(id: number): Observable<boolean> {
    return this.api.delete<ItemDeletedResponse>('uploads/' + id)
      .pipe(map(response => response.status.toLocaleUpperCase() === 'OK'));
  }

  linkUpload(id: number, patientId: number, commentId?: number | null): Observable<boolean> {
    return this.api.post<ItemUpdatedResponse>('uploads/' + id + '/link', { id: id, patientId: patientId, commentId: commentId ?? null })
      .pipe(map(response => response.status.toLocaleUpperCase() === 'OK'));
  }

}
